export default __webpack_public_path__ + "static/media/1399.29952bc9.png";